import AuctionItemTable from './AuctionItemTable';

export default AuctionItemTable;
